module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/portfolio-basic-grid-312a5d3e572e431aa56af77a252afb8a.jpg";